import { ActivityFieldHydration } from '../../../shared/modules/activity/dtos/activity-field-hydration.dto';
import { ActivityLinkHydration } from '../../../shared/modules/activity/dtos/activity-link-hydration.dto';
import { AgentSearchDto } from '../../agents';
import { CustomerSearchDto } from '../../customers';
import { LocationSearchDto } from '../../locations';
import { RentalReservationSearchDto } from '../../rental-reservations';
import { VehicleCategorySearchDto } from '../../vehicle-categories';
import { VehicleSearchDto } from '../../vehicles';

/**
 * Resolved related records for a rental agreement activity event, keyed by relation.
 */
export class RentalAgreementActivityEventHydration {
  vehicle?: ActivityFieldHydration<VehicleSearchDto>;
  vehicleCategory?: ActivityFieldHydration<VehicleCategorySearchDto>;
  customer?: ActivityFieldHydration<CustomerSearchDto>;
  agent?: ActivityFieldHydration<AgentSearchDto>;
  pickupLocation?: ActivityFieldHydration<LocationSearchDto>;
  dropOffLocation?: ActivityFieldHydration<LocationSearchDto>;
  rentalReservation?: ActivityFieldHydration<RentalReservationSearchDto>;
  link?: ActivityLinkHydration;
}
